import { BorderBottom } from '@mui/icons-material';
import { grey, red } from '@mui/material/colors';
import theme from 'src/theme/index';

export const cardBase = {
    marginBottom: 3,
    borderRadius: '16px',
    boxShadow: "none",
    border: `1px solid ${grey[300]}`,
};

export const cardHeader = {
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    //color: theme.palette.primary.main,
    fontSize: '12px',
    fontWeight: 400,
    padding: "12px 16px",
    // borderRadius: '8px',
}